import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-select-loan-type',
  templateUrl: './select-loan-type.component.html',
  styleUrls: ['./select-loan-type.component.scss']
})
export class SelectLoanTypeComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

}
